module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12 divDeveloperDocumentationDownload"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 div_path_3 divDeveloperDocumataion"
  }, [_c('h1', {
    staticClass: "developerDocumataionOverviewTitle nuwaDevelop"
  }, [_vm._v(_vm._s(_vm.$t('developer_documataion_overview_01_title')))]), _vm._v(" "), _c('p', {
    staticClass: "developerDocumataionOverviewText "
  }, [_vm._v("\n                " + _vm._s(_vm.$t('developer_documataion_overview_01_text')) + "\n            ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 div_path_3",
    staticStyle: {
      "padding-top": "47px"
    }
  }, [_c('h1', {
    staticClass: "developerDocumataionOverviewTitle nuwaDevelop"
  }, [_vm._v(_vm._s(_vm.$t('developer_documataion_overview_02_title')))]), _vm._v(" "), _c('p', {
    staticClass: "developerDocumataionOverviewText "
  }, [_vm._v("\n                " + _vm._s(_vm.$t('developer_documataion_overview_02_text')) + "\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "Line_3"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87318ce4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ListApp2.vue
// module id = 1502
// module chunks = 1